// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown[data-v-4eff34fe]{border-bottom:none}.pintura-sidebar[data-v-4eff34fe]{display:flex;background:#fff;height:100%;flex-direction:column;position:relative;box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.sidebar__section[data-v-4eff34fe]{background:transparent}.pintura-sidebar .cv-header.bx--header[data-v-4eff34fe]{z-index:800}", ""]);
// Exports
module.exports = exports;
